module.exports = __webpack_public_path__ + "img/CharacterSheetPage2.bea5634d.png";